import Topbar from './Topbar';
import {Navbar} from './Navbar';

export default function Header() {
  return (
    <>
      <Topbar />
      <Navbar
        links={[
          {
            link: '',
            label: 'About us',
            links: [
              {link: '/about-quality', label: 'About Quality Healthcare'},

              {link: '/our-services', label: 'Our services'},
              {link: '/supported-living', label: 'Supported living'},
              {link: '/find-a-home', label: 'Find a home'},
              {link: '/consultation', label: 'Consultation'},
              {link: '/team', label: 'Our team'},
              {link: '/how-we-deliver', label: 'How we deliver our care'},
              {link: '/work-with', label: 'Who we work with'},
              {link: '/our-values', label: 'Our values'},
              {link: '/excellence', label: 'Quality and clinical excellence'},
              {link: '/funding', label: 'Funding your care'},
              {link: '/testimonials', label: 'Testimonials'},
            ],
          },

          {
            link: '',
            label: 'Our care',
            links: [
              {link: '/our-care', label: 'Specialist care'},

              {link: '/brain-injury', label: 'Brain injury'},

              {link: '/spinal-injury', label: 'Spinal injury'},

              {link: '/learning-disability', label: 'Learning disability'},

              {link: '/nursing-care', label: 'Nursing care'},

              {
                link: '/neurological-conditions',
                label: 'Neurological conditions',
              },

              {link: '/children', label: 'Children and young people'},

              {
                link: '/ventilation-and-airway',
                label: 'Ventilation and airway management',
              },
            ],
          },
          {
            link: '',
            label: 'Work with us',
            links: [
              /*{link: '/vacancies', label: 'Vacancies'},*/
              {link: '/work-with-us', label: 'Working for Quality healthcare'},
              {link: '/recruitment-process', label: 'Recruitment process'},

              {link: '/training', label: 'Training and development'},
              {
                link: '/reward',
                label: 'Reward and recognition',
              },
            ],
          },
        ]}
      />
    </>
  );
}
